// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3uLXW","image":"Header_image__2oIOp","name":"Header_name__2nAG3","info":"Header_info__rDyVc","infoRow":"Header_infoRow__3gcdX"};